// extracted by mini-css-extract-plugin
module.exports = {"validate-text":"style_validate-text__1NSQc","validate-top":"style_validate-top__g025c","validate-bottom":"style_validate-bottom__2-jfh"};